import React from 'react';
import { CalendarXIcon, RefreshCwIcon, RepeatIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { COST_STATS } from '../../data/content';
const ICONS = [CalendarXIcon, RefreshCwIcon, RepeatIcon];
export function SocialStats() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-226" data-mp="1gj11wtfilaz8">
      <div className="mx-auto max-w-5xl" data-id="element-227" data-mp="1ggobdrvoxsak">
        <Reveal className="text-center" data-id="element-228" data-mp="1linfj3z98t8k">
          <SectionBadge data-id="element-229" data-mp="1lhlt63csgkbj">El problema real</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-230" data-mp="1qg5f43rdtw3w">
            El verdadero costo de <span className="u-lime" data-id="element-231" data-mp="1v870cf6j2x62">improvisar tus clases</span> todas las semanas
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-232" data-mp="1z8qvxebgdsq3">
            <strong className="font-bold text-snow" data-id="element-233" data-mp="249wptfgunm17">No es solamente el tiempo.</strong> Es llegar cansada a la noche y
            todavía tener que pensar qué enseñar, buscar música, ordenar ejercicios y tratar de no repetir nuevamente
            lo mismo.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-3" data-id="element-234" data-mp="368ivgan01u4x">
          {COST_STATS.map((stat, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <Reveal key={stat.title} delay={index * 80} as="article" data-id="element-235" data-mp="2x8vs3japme98" data-mpi={index}>
                <div className="h-full rounded-2xl border border-ink-line bg-ink p-5 text-left sm:p-6" data-id="element-236" data-mp="2xayrgtxr5jqm">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-237" data-mp="3u0pl6qy7z2vd">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-238" data-mp="3l6b90x8zk8gh" />
                  </span>
                  <p className="mt-4 font-display text-3xl leading-none text-lime" data-id="element-239" data-mp="3g7hur2lvkdf9">{stat.value}</p>
                  <h3 className="mt-4 text-base font-bold text-snow" data-id="element-240" data-mp="hhhmpfwe30y8">{stat.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-241" data-mp="hjawh42au1ag">{stat.desc}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}